/**
 * Facebook share helper. Mirrors legacy `amri.social.js`'s
 * `Amri.Social.shareOnFacebook(url)` API — opens the Share Dialog in a
 * popup window (no app ID required).
 *
 * Wires to anchors with `data-share="facebook"` and an optional
 * `data-share-url="<url>"` (defaults to `location.href`).
 */

const SHARE_BASE = 'https://www.facebook.com/sharer/sharer.php?u=';

function handleClick(e: Event): void {
    const target = e.target as HTMLElement | null;
    if (!target) {
        return;
    }

    const host = target.closest<HTMLElement>('[data-share="facebook"]');
    if (!host) {
        return;
    }

    e.preventDefault();
    const url = host.dataset.shareUrl ?? window.location.href;
    const shareUrl = SHARE_BASE + encodeURIComponent(url);
    window.open(shareUrl, 'facebook-share', 'width=600,height=400,resizable=yes,scrollbars=yes');
}

export function initSocialShare(): void {
    document.addEventListener('click', handleClick);
}
